export const DASHBOARD_ITEM = { id: "dashboard", label: "Tableau de bord" };

export const MENU = [
	{
		id: "accueil",
		label: "Accueil",
		items: [
			{ id: "carrousel", label: "Carrousel principal", api: "carrousel", permission: "carousel_admin_panel" },
			{ id: "partner", label: "Slider partenaires", api: "partner", permission: "partner_admin_panel" },
			{ id: "divers", label: "Divers", api: ".", permission: "div_home_data_admin_panel" },
		],
	},
	{
		id: "evenements",
		label: "Évènements",
		items: [
			{ id: "event-list", label: "Liste des évènements", api: "evenement", permission: "event_admin_panel" },
			{ id: "event-slider", label: "Slider évènement", api: "evenement-slider", permission: "event_admin_panel" },
		],
	},
	{
		id: "calendrier",
		label: "Calendrier",
		items: [
			{ id: "calendrier-ouverture", label: "Calendrier d'ouverture", api: ".", permission: "calendar_admin_panel" },
		],
	},
	{
		id: "utilisateurs",
		label: "Utilisateurs",
		items: [
			{ id: "users", label: "Gestion des utilisateurs", api: "users", permission: "user_management" },
			{ id: "roles", label: "Rôles & permissions", api: "roles", permission: "role_management" },
		],
	},
	{
		id: "divers",
		label: "Divers",
		items: [
			{ id: "confGeneral", label: "Configuration générale", api: "globalproperties", permission: "" },
		],
	},
];

export const ACTIONS = [
	{ id: "create", label: "Créer" },
	{ id: "update", label: "Mettre à jour" },
	{ id: "delete", label: "Supprimer" },
]; 

export const EMPTY_FORM = { titre: "", description: "", media: "", ordre: "" };

export const DASHBOARD_DATA = {
	metrics: [
		{ id: "visits", label: "Visites (24h)", value: "4 582", trend: "+12%" },
		{ id: "orders", label: "Commandes en cours", value: "37", trend: "+5%" },
		{ id: "conversion", label: "Taux de conversion", value: "3,8%", trend: "+0,6 pt" },
		{ id: "stock", label: "Ruptures à surveiller", value: "5", trend: "-" },
	],
	google: { note: "4.7", total: "1 284 avis", badge: "Google Reviews" },
	reviews: [
		{
			id: 1,
			name: "Sophie L.",
			rating: 5,
			comment: "Bouquet magnifique livré à temps. Merci pour la carte personnalisée !",
			timestamp: "Il y a 2h",
		},
		{
			id: 2,
			name: "David M.",
			rating: 4,
			comment: "Accueil chaleureux en boutique, je reviendrai pour la Saint-Valentin.",
			timestamp: "Il y a 5h",
		},
	],
	orders: [
		{ id: "CMD-1045", customer: "Julie P.", status: "Préparation", amount: "68 €", eta: "15:30" },
		{ id: "CMD-1044", customer: "Cabinet Lenoir", status: "En livraison", amount: "142 €", eta: "14:10" },
		{ id: "CMD-1043", customer: "Arthur B.", status: "Payée", amount: "36 €", eta: "–" },
	],
};
